import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios';
import {
  getNews
} from '@/apis/news'
import {
  getSwiperLists
} from '@/apis/dashbord'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    newsData: null,
    isCloseNav:true,
  },
  getters: {

  },
  mutations: {
    SET_NEWSLIST(state, data) {
      state.newsData = data
    },
  },
  actions: {
    closeNav(context,data){
      context.commit("CLOSE_NAV",data)
    },
    getNewsList(context, params) {
      getNews({
        params
      }).then(res => {
        if (res.data.code == 200) {
          res.data.rows.forEach(item => {
            // item.imgSrc = axios.defaults.baseURL + item.imgSrc
            item.imgSrc = process.env.VUE_APP_BASE_API + item.imgSrc
            // console.log(process.env.VUE_APP_BASE_API);
            // item.imgSrc =item.imgSrc
          });
          context.commit("SET_NEWSLIST", res.data)
        }
      })
    },


  },
  modules: {
  }
})
